var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarktngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.078,
    height: 70.219,
    viewBox: "0 0 69.078 70.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1628",
    "data-name": "Rectangle 1628",
    width: 69.078,
    height: 70.219,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marktng-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60320",
    "data-name": "Path 60320",
    d: "M22.928,7.827a.876.876,0,0,0-.877-.877H19.4A22.809,22.809,0,0,1,7.231,3.635.877.877,0,0,0,6.3,5.124,24.562,24.562,0,0,0,19.4,8.7h2.652a.876.876,0,0,0,.877-.877",
    transform: "translate(12.881 7.661)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60321",
    "data-name": "Path 60321",
    d: "M68.2,39.236h-3.86a.877.877,0,0,0-.88.877V43.59l-6.2-4.8a14.11,14.11,0,0,0-2.3-28.032H33.1c-10.037,0-15.519-5.3-16.475-6.311a4.823,4.823,0,0,0-9.632.386V15.519C3.069,16.051,0,20.023,0,24.877s3.069,8.829,6.993,9.361V44.925a4.823,4.823,0,0,0,9.632.382c.928-.982,6.129-5.976,15.6-6.279V42.26a3.663,3.663,0,0,0,1.409,6.757,3.676,3.676,0,0,0,.73,4.749,3.667,3.667,0,0,0,.194,5.74,3.651,3.651,0,0,0,.892,5.906,5.085,5.085,0,0,0,1.3,3.187,4.75,4.75,0,0,0,3.5,1.619H46.56a7.532,7.532,0,0,0,6.821-4.4h1.463a.9.9,0,0,0,.4-.1l8.214-4.214v3.828a.877.877,0,0,0,.88.88H68.2a.877.877,0,0,0,.88-.88V40.112a.877.877,0,0,0-.88-.877M6.993,32.51c-2.958-.539-5.24-3.755-5.24-7.634s2.282-7.092,5.24-7.63Zm7.914,12.415a3.081,3.081,0,0,1-6.161,0V4.835a3.081,3.081,0,0,1,6.161,0ZM39.988,12.517H54.959a12.364,12.364,0,0,1,0,24.727H39.988ZM16.663,42.856V6.9A25.071,25.071,0,0,0,33.1,12.517h5.132V37.244H33.1a25.073,25.073,0,0,0-16.437,5.613m21.859-1.151H34.139l-.159,0,0-2.712h3.678c.016.214.041.443.083.682.006.045.019.092.029.137a5.309,5.309,0,0,0,.2.755,2.479,2.479,0,0,0,.089.242,4.185,4.185,0,0,0,.465.892M46.56,68.463H40.249a2.991,2.991,0,0,1-2.193-1.039,3.474,3.474,0,0,1-.816-1.6H51.408a5.793,5.793,0,0,1-4.848,2.639m16.9-8.921L54.63,64.068H37.094a1.917,1.917,0,0,1,.01-3.834.878.878,0,0,0,0-1.756h-.36a1.917,1.917,0,0,1,0-3.834.878.878,0,1,0,0-1.756,1.917,1.917,0,0,1,0-3.834.878.878,0,1,0,0-1.756h-2.6a1.917,1.917,0,0,1,0-3.834H46.981a.878.878,0,0,0,0-1.756h-4.3a6.67,6.67,0,0,1-.877-.057c-.086-.01-.159-.032-.239-.048a3.653,3.653,0,0,1-.472-.115,2.152,2.152,0,0,1-.229-.092,2.394,2.394,0,0,1-.338-.172c-.064-.041-.127-.086-.185-.131a2.189,2.189,0,0,1-.249-.236c-.048-.054-.1-.105-.137-.163a2.246,2.246,0,0,1-.185-.319c-.029-.057-.061-.112-.086-.172a3.45,3.45,0,0,1-.15-.484c-.006-.032-.019-.057-.026-.092A5.151,5.151,0,0,1,39.424,39H54.659l8.8,6.811Zm3.863,4.924H65.215V40.989h2.107Z",
    transform: "translate(0 0)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60322",
    "data-name": "Path 60322",
    d: "M27.333,8.408a.876.876,0,0,0-.877-.877H14.488a.877.877,0,1,0,0,1.753H26.456a.876.876,0,0,0,.877-.877",
    transform: "translate(29.765 16.473)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60323",
    "data-name": "Path 60323",
    d: "M14.954,7.444h8.982a.878.878,0,0,0,0-1.756H14.954a.878.878,0,0,0,0,1.756",
    transform: "translate(30.791 12.442)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60324",
    "data-name": "Path 60324",
    d: "M24.814,10.25a.876.876,0,0,0-.877-.877H14.956a.877.877,0,1,0,0,1.753h8.982a.876.876,0,0,0,.877-.877",
    transform: "translate(30.788 20.502)",
    fill: "#ec431f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarktngIcon);
export default __webpack_public_path__ + "static/media/marktng-icon.30abe4346c76eab60532154ef92d9219.svg";
export { ForwardRef as ReactComponent };